module.exports = __webpack_public_path__ + "media/images/features/draft/thumb-voice-1-21f52a9f5dd9e1674c4a3a3336c4a149.jpg";